module.exports = __webpack_public_path__ + "static/media/flight tickets.16a909a1.png";